export const SESSION_KEY = "QCBOT_LIST_SESSION";
export const SESSION_KEY_ARCHIEVE = "QCBOT_LIST_SESSION_ARCHIEVE";

export const getInferenceItemStatus = (data) => {
  if (data?.is_un_trained_sku) {
    if (data?.is_qc_bot_audited_sku) {
      return "Audited";
    } else {
      return "UNTRAINED";
    }
  }

  let status = data?.status;
  if (status !== "MATCHED") {
    if (data?.actual_quantity > data?.expected_quantity) status = "Extra";
    else status = "Missing";
  } else status = "No error";

  if (data?.is_qc_bot_audited_sku) status = "Audited";
  else if (data?.is_unverifiable_sku) status = "Can’t confirm";

  return status;
};

//Is mobile
export const isMobile = ()=> {
  const regex = /Mobi|Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i;
  let mobile = regex.test(navigator.userAgent);// ? (window.orientation ==0 ? true: false):false;
    return mobile
}
export const detectDeviceType = ()=> {
    const ua = navigator.userAgent;

    if (/Mobi|Android/i.test(ua)) {
        return "mobile";
    } else if (/Tablet|iPad/i.test(ua)) {
        return "tablet";
    } else {
        return "desktop";
    }
}
const iOS1to12quirk = ()=> {
  var audio = new Audio(); // temporary Audio object
  audio.volume = 0.5; // has no effect on iOS <= 12
  return audio.volume === 1;
};
/*export const isTabletDevice = ()=> {
  const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  const iOS_1to12 = /iPad|iPhone|iPod/.test(navigator.platform);
  const iOS13_iPad = (navigator.platform.includes("Mac") && navigator.maxTouchPoints > 1);
  const isIOS = !window.MSStream && (iOS_1to12 || iOS13_iPad || iOS1to12quirk());

  let mobile = regex.test(navigator.userAgent);//? (window.orientation ==0 ? true: false):false;

  if(!mobile){
    return  isIOS;
  }

  return mobile;
}*/
export const isTabletDevice = ()=> {
    const ua = navigator.userAgent || '';
    return (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) || /iPad/.test(ua);
   // return isIPad;
}

export const defaultPalletBox = ()=>{
  return(
      <>
        <h1>Pallet</h1>
      </>
  )
}
